module.exports = __webpack_public_path__ + "static/media/1007151.349ab8b9.jpg";